/* Keep the blue Add to Cart button on the full order total (variant x qty + options). */
(function () {
  const ONE_TIME_MODES = ['ONE_TIME_PER_ORDER', 'ONE_TIME_PER_PRODUCT', 'ONE_TIME_PER_LINE_ITEM'];
  const marketOptionPrices = new Map();
  const pendingMarketOptionPrices = new Set();

  function formatMoney(cents) {
    const boldFormat = window.BOLD && BOLD.common && BOLD.common.Shopify && BOLD.common.Shopify.formatMoney;
    if (typeof boldFormat === 'function') return boldFormat(cents);

    const moneyFormat = (window.theme && theme.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = String(Math.round(cents / 100));
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function loadMarketOptionPrice(optionValue, onDone) {
    const optionVariantId = String(optionValue.variantId || '');
    const productHandle = optionValue.productHandle;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    if (!optionVariantId || !productHandle || marketOptionPrices.has(optionVariantId) || pendingMarketOptionPrices.has(optionVariantId)) {
      return;
    }

    pendingMarketOptionPrices.add(optionVariantId);
    fetch(root + 'products/' + encodeURIComponent(productHandle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('option product');
        return response.json();
      })
      .then(function (optionProduct) {
        const optionVariant = (optionProduct.variants || []).find(function (variant) {
          return String(variant.id) === optionVariantId;
        });
        marketOptionPrices.set(optionVariantId, typeof optionVariant?.price === 'number' ? optionVariant.price : optionValue.price);
      })
      .catch(function () {
        marketOptionPrices.set(optionVariantId, optionValue.price);
      })
      .finally(function () {
        pendingMarketOptionPrices.delete(optionVariantId);
        if (typeof onDone === 'function') onDone();
      });
  }

  function variantPrice(form) {
    const variantId = form.querySelector('[name="id"]')?.value;
    const boldPrice = window.BOLD && BOLD.common && BOLD.common.Shopify && BOLD.common.Shopify.variants && BOLD.common.Shopify.variants[variantId] && BOLD.common.Shopify.variants[variantId].price;
    if (typeof boldPrice === 'number') return boldPrice;

    const productJson = form.querySelector('[data-product-json]');
    if (!productJson) return null;
    try {
      const product = JSON.parse(productJson.textContent);
      const variant = (product.variants || []).find(function (item) {
        return String(item.id) === String(variantId);
      });
      return variant ? variant.price : null;
    } catch (error) {
      return null;
    }
  }

  function quantityFor(form, optionProduct) {
    if (optionProduct && typeof optionProduct.getQuantity === 'function') {
      const boldQty = optionProduct.getQuantity();
      if (typeof boldQty === 'number' && boldQty > 0) return boldQty;
    }
    const input = form.querySelector('[name="quantity"]');
    const qty = parseInt(input && input.value, 10);
    return qty > 0 ? qty : 1;
  }

  function updateForm(form) {
    if (!form || form.querySelector('.cro-cap-option-heading')) return;

    const buttonPrices = form.querySelectorAll('[data-button-price]');
    if (!buttonPrices.length) return;

    const optionProduct = window.BOLD && BOLD.options && BOLD.options.app && typeof BOLD.options.app.getOptionProductByForm === 'function'
      ? BOLD.options.app.getOptionProductByForm(form)
      : null;
    const basePrice = (optionProduct && optionProduct.priceHandler && typeof optionProduct.priceHandler.productPrice === 'number')
      ? optionProduct.priceHandler.productPrice
      : variantPrice(form);

    if (typeof basePrice !== 'number') return;

    const quantity = quantityFor(form, optionProduct);
    let optionsTotal = 0;

    if (optionProduct && typeof optionProduct.getActivePricedOptionValues === 'function') {
      optionsTotal = optionProduct.getActivePricedOptionValues().reduce(function (total, optionValue) {
        const optionVariantId = String(optionValue.variantId || '');
        const registeredPrice = window.BOLD && BOLD.common && BOLD.common.Shopify && BOLD.common.Shopify.variants && BOLD.common.Shopify.variants[optionVariantId] && BOLD.common.Shopify.variants[optionVariantId].price;
        const cachedMarketPrice = marketOptionPrices.get(optionVariantId);

        if (typeof registeredPrice !== 'number' && typeof cachedMarketPrice !== 'number') {
          loadMarketOptionPrice(optionValue, function () { updateForm(form); });
        }

        const optionPrice = (typeof registeredPrice === 'number' ? registeredPrice : null)
          ?? (typeof cachedMarketPrice === 'number' ? cachedMarketPrice : null)
          ?? optionValue.price
          ?? 0;
        const isOneTime = ONE_TIME_MODES.indexOf(optionValue.quantityMode) !== -1;
        const optionQuantity = (optionValue.qty || 1) * (isOneTime ? 1 : quantity);
        return total + (optionPrice * optionQuantity);
      }, 0);
    }

    const formattedTotal = formatMoney((basePrice * quantity) + optionsTotal);
    buttonPrices.forEach(function (buttonPrice) {
      if (buttonPrice.textContent !== formattedTotal) buttonPrice.textContent = formattedTotal;
    });
  }

  function bind(form) {
    if (!form || form.dataset.orderTotalBound === 'true' || form.querySelector('.cro-cap-option-heading')) return;
    form.dataset.orderTotalBound = 'true';

    const refresh = function () {
      window.requestAnimationFrame(function () { updateForm(form); });
    };

    form.addEventListener('change', refresh);
    form.addEventListener('input', refresh);
    form.querySelectorAll('[data-button-price]').forEach(function (buttonPrice) {
      const observer = new MutationObserver(function () { updateForm(form); });
      observer.observe(buttonPrice, { characterData: true, childList: true, subtree: true });
    });
    refresh();
  }

  function bindAll() {
    document.querySelectorAll('form[data-product-form]').forEach(bind);
  }

  function boot() {
    bindAll();
    if (window.BOLD && BOLD.options && BOLD.options.app && typeof BOLD.options.app.on === 'function') {
      BOLD.options.app.on('options_loaded', bindAll);
    }
  }

  let attempts = 0;
  const timer = window.setInterval(function () {
    attempts += 1;
    boot();
    if ((window.BOLD && BOLD.options && BOLD.options.app) || attempts > 40) {
      window.clearInterval(timer);
      boot();
    }
  }, 250);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
